/*
 * Copyright (c) 2022 by Leyton Group - All Rights Reserved.
 * This source code, and resulting software, is the confidential and proprietary information
 * ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 * of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 * and shall use it only in accordance with the terms and conditions of any and all license
 * agreements you have entered into with The Company.
 */

import store from "@/store";

const isAllowed = function(permission) {
    const currentUser = store.getters['account/getCurrentUser'];
    if (currentUser.admin) {
        return true;
    } else {
        return currentUser.role.permissions.map(perm => perm.name).includes(permission);
    }
};

const isAdminAndB2B2B = function() {
    const currentUser = store.getters['account/getCurrentUser'];
    return currentUser.admin && currentUser.clientType === 'B2B2B';
};

const isAdmin = function() {
    const currentUser = store.getters['account/getCurrentUser'];
    return currentUser.admin;
};

export const routeUtils = {
    isAllowed,
    isAdminAndB2B2B,
    isAdmin
};
